<div>
    <mat-expansion-panel #panel [expanded]="isExpanded">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <h4>Pesquisar</h4>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div [formGroup]="form" class="mt-4 mx-auto">
            <div class="flex justify-center items-start gap-4">
                <div class="flex justify-between items-center w-6/12 gap-2">
                    <mat-form-field class="input-tg w-6/12 ml-2" appearance="outline" hideRequiredMarker>
                        <mat-label>Data Inicio</mat-label>
                        <input matInput [matDatepicker]="dateInitial" formControlName="dateInitial" />
                        <mat-datepicker-toggle matSuffix [for]="dateInitial"></mat-datepicker-toggle>
                        <mat-datepicker #dateInitial></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="input-tg w-6/12" appearance="outline" hideRequiredMarker>
                        <mat-label>Data Fim</mat-label>
                        <input matInput [matDatepicker]="dateEnd" formControlName="dateEnd" />
                        <mat-datepicker-toggle matSuffix [for]="dateEnd"></mat-datepicker-toggle>
                        <mat-datepicker #dateEnd></mat-datepicker>
                    </mat-form-field>

                </div>
                <div class="flex flex-row justify-between items-center w-6/12">


                    <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                        <mat-label>Cliente</mat-label>
                        <input matInput formControlName="cliente" readonly />
                        @if (this.form.get('cliente')!.enabled) {
                        <button mat-icon-button matSuffix (click)="addClient()">
                            <mat-icon>add</mat-icon>
                        </button>
                        }
                    </mat-form-field>

                </div>

            </div>


            <div class="flex flex-row justify-between items-center w-full">
                <mat-form-field class="input-tg w-4/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="statusIds" multiple>
                        <mat-option *ngFor="let status of listStatus" [value]="status.value">
                            {{ status.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="input-tg w-4/12 px-2">
                    <mat-label>Origem</mat-label>

                    <input matInput type="text" formControlName="origem" [matAutocomplete]="autoOrigin" />

                    <mat-autocomplete #autoOrigin="matAutocomplete" autoActiveFirstOption
                        (optionSelected)="onOriginSelected($event)">
                        <mat-option *ngFor="let opt of filteredOrigins | async" [value]="opt.descricao">
                            {{ opt.descricao }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="outline" class="input-tg w-4/12 px-2">
                    <mat-label>Destino</mat-label>

                    <input matInput type="text" formControlName="destino" [matAutocomplete]="autoDestino" />

                    <mat-autocomplete #autoDestino="matAutocomplete" autoActiveFirstOption
                        (optionSelected)="onOriginSelected($event)">
                        <mat-option *ngFor="let opt of filteredDestinations | async" [value]="opt.descricao">
                            {{ opt.descricao }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div class="flex flex-row justify-between items-center w-full">
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Tipo Serviço</mat-label>
                    <mat-select formControlName="typeService">
                        <mat-option MatDatepicker *ngFor="let typeService of listTypeService"
                            [value]="typeService.descricao">
                            {{ typeService.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Serviço</mat-label>
                    <input matInput type="text" formControlName="service" />
                    <!-- <mat-select formControlName="service">
                        <mat-option MatDatepicker *ngFor="let driver of listTypeDriver" [value]="driver.id">
                            {{ driver.nome }}
                        </mat-option>
                    </mat-select> -->
                </mat-form-field>
            </div>
            <div class="flex flex-row justify-between items-center w-full">
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Tipo Veículo</mat-label>
                    <mat-select formControlName="typeVehicle">
                        <mat-option MatDatepicker *ngFor="let vehicleType of listTypeVehicle"
                            [value]="vehicleType.descricao">
                            {{ vehicleType.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Tipo Motorista</mat-label>
                    <mat-select formControlName="typeDriver">
                        <mat-option MatDatepicker *ngFor="let typeDriver of listTypeDriver"
                            [value]="typeDriver.descricao">
                            {{ typeDriver.descricao }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="flex flex-row justify-between items-center w-full">
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Código TG</mat-label>
                    <input matInput type="text" formControlName="tgCode" />
                </mat-form-field>
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Código OS</mat-label>
                    <input matInput type="text" formControlName="osCode" />
                </mat-form-field>
            </div>
            <!-- <div class="flex flex-row justify-between items-center w-full">
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Veículo</mat-label>
                    <input matInput type="text" formControlName="vehicle" [matAutocomplete]="autoVehicle" />
                    <mat-autocomplete #autoVehicle="matAutocomplete" autoActiveFirstOption
                        (optionSelected)="onDriverSelected($event)">
                        <mat-option *ngFor="let opt of filteredVehicles | async" [value]="opt.placa">
                            {{ opt.placa }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
                    <mat-label>Motorista</mat-label>
                    <input matInput type="text" formControlName="driver" [matAutocomplete]="autoDriver" />
                    <mat-autocomplete #autoDriver="matAutocomplete" autoActiveFirstOption
                        (optionSelected)="onDriverSelected($event)">
                        <mat-option *ngFor="let opt of filteredDrivers | async" [value]="opt.id">
                            {{ opt.nome }} / {{ opt.cpf }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div> -->
        </div>
        <div class="mb-3 flex justify-end items-center gap-2">
            <button class="btn-icon" (click)="reateForm()"
                [matTooltip]="'Limpar Pesquisar'"><mat-icon>replay</mat-icon></button>
            <button class="btn-icon" (click)="searchFleet()"
                [matTooltip]="'Pesquisa'"><mat-icon>search</mat-icon></button>
        </div>
        <div class="mt-4">
            <!-- @if (checkPermission('pesquisar-paginado')) {
      <form-search [search]="inputSearch" (responseSearch)="search($event)" />
        } -->
            <!-- <div>
                @if (!loading) {
                <div *ngIf="itemsList.length > 0; else noItems">


                    <table-list-simple [dataSource]="itemsList" [columns]="columns" (selectItem)="editItem($event)"
                        (deleteItem)="deleteItem($event)" />


                </div>
                <ng-template #noItems>
                    <div class="text-center text-gray-500 py-4">
                        Nenhum item encontrado.
                    </div>
                </ng-template>
                } @else {
                <div>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                }
            </div> 
            @if (itemsList.length > 0) {
            <div>
                <div class="tab-overflow">
                    <table mat-table [dataSource]="itemsList" class="mat-elevation-z8">
                        @for (column of columns; track column.keyColumn) {
                        <ng-container matColumnDef="{{ column.keyColumn }}">
                            <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
                            <td mat-cell *matCellDef="let element">
                                @if (column.keyColumn == 'action') {
                                <div class="flex justify-center items-center gap-3">
                                    @if (column.key.edit) {
                                    <mat-icon class="btn-icon-outline" fontIcon="edit" (click)="editItem(element)" />
                                    }
                                    @if (column.key.delete) {
                                    <mat-icon class="btn-icon-outline" fontIcon="delete"
                                        (click)="deleteItem(element)" />
                                    }
                                </div>
                                } @else {
                                {{ element[column.key] }}
                                }
                            </td>
                        </ng-container>
                        }
                        <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
                    </table>
                </div>
                <mat-paginator #paginator [pageSize]="5"> </mat-paginator>
            </div>
        }-->
        </div>
    </mat-expansion-panel>

</div>